module.exports = __webpack_public_path__ + "static/media/onClose.3250ab5d.svg";